addClassToImg();

function addClassToImg() {
	if ($('.js-faq-entry').length) {
		$('.js-faq-entry img').each(function() {
			if ($(this).attr('alt') == 'fullwidth') {
				$(this)
					.parent()
					.addClass('full-container');
			}
		});
	}
}
